import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "prod",
    aws_cognito_region: "ap-southeast-2",
    aws_cognito_identity_pool_id: "ap-southeast-2:2ad40eff-fa63-49ea-b7ee-be0664943520",
    aws_user_pools_id: "ap-southeast-2_ncQei8D6h",
    aws_user_pools_web_client_id: "4cqbqhfnar654bd29ild92d9a4",
    Auth: {
      identityPoolId: "ap-southeast-2:2ad40eff-fa63-49ea-b7ee-be0664943520",
      region: "ap-southeast-2",
      userPoolId: "ap-southeast-2_ncQei8D6h",
      userPoolWebClientId: "4cqbqhfnar654bd29ild92d9a4",
    },
    oauth: {
      domain: "whs-safer-prod-jp.auth.ap-southeast-2.amazoncognito.com",
      redirectSignIn: "https://prod.jp.safer.whs.amazon.dev",
      redirectSignOut: "https://prod.jp.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };
  Auth.configure(config);
}
